export const menLevelTwo = [
    {
      name: "Topwear",
      categoryId: "men_topwear",
      parentCategoryId: "men",
      level: 2,
    },
    {
      name: "Bottomwear",
      categoryId: "men_bottomwear",
      parentCategoryId: "men",
      level: 2,
    },
    {
      name: "Innerwear And Sleepwear",
      categoryId: "men_innerwear_and_sleepwear",
      parentCategoryId: "men",
      level: 2,
    },
    {
      name: "Footwear",
      categoryId: "men_footwear",
      parentCategoryId: "men",
      level: 2,
    },
    {
      name: "Personal Care And Grooming",
      categoryId: "men_personal_care_grooming",
      parentCategoryId: "men",
      level: 2,
    }
  ];
  